<template>
  <bulk-update-wrapper
    :saving="saving"
    title="Archive"
    :button-label="buttonLabel"
    :has-changes="true"
    @save="save"
    @dismiss="dismiss"
  >
    <template #error-snackbar>
      <vs-snackbar :value="error" type="error" sticky @input="clearSnackbar">
        Failed to archive jobs
      </vs-snackbar>
    </template>
  </bulk-update-wrapper>
</template>

<script setup lang="ts">
import BulkUpdateWrapper from '../common/BulkUpdateWrapper.vue'
import { ref, computed } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { BulkUpdateResponse } from '@/models/types/bulk-update-response'
import { bulkArchive } from '@/api/jobs'

const emits = defineEmits<{
  (e: 'dismiss')
  (e: 'updated', { message, updatedJobs }: BulkUpdateResponse)
}>()

const props = defineProps<{
  selectedJobs: JobJson[]
}>()

const error = ref(false)
const saving = ref(false)

const dismiss = () => emits('dismiss')
const clearSnackbar = () => (error.value = false)

const buttonLabel = computed<string>(() => {
  const jobCount = props.selectedJobs.length
  return jobCount >= 2 ? `Archive ${jobCount} jobs` : 'Archive job'
})

const save = async () => {
  saving.value = true
  try {
    await bulkArchive(props.selectedJobs.map((job) => job.id))
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) =>
      Object.assign(job, { isArchived: true }),
    )
    emits('updated', { message: 'Jobs archived', updatedJobs })
  } catch (err) {
    error.value = true
  } finally {
    saving.value = false
  }
}
</script>
